<template>
  <div class="relative flex basis-full flex-col items-center text-center xl:max-w-[420px]">
    <h3 v-if="data?.title" class="mb-3 font-serif text-5xl font-bold text-blue lg:text-6xl">
      {{ data?.title }}
    </h3>
    <HeaderLine />
    <div
      v-if="data?.copy"
      class="mt-7 font-sans text-base leading-snug text-black lg:mt-12 lg:text-lg"
      v-html="data?.copy"
    ></div>
  </div>
</template>

<script setup lang="ts">
import HeaderLine from '../atoms/Icons/HeaderLine.vue'

export interface IFactsCard {
  title?: string
  copy?: string
}

interface Props {
  data: IFactsCard
}

defineProps<Props>()
</script>
